(function() {
    let currentProducts = [];
    let ajaxUrl = php_vars.ajaxUrl;

    window.addEventListener('load', function() {
        currentProducts = readSavedProducts();
        let compareButtons = document.querySelectorAll('[data-add-to-compare]');
        let compareRemoveButton = document.querySelector('[data-compare-remove]');
        let compareProductsList = document.querySelector('[data-compare-products-list]');

        if (compareButtons.length ) {
            compareButtons.forEach(function(item) {
                let id = item.getAttribute('data-add-to-compare');

                if (currentProducts.includes(id) ) {
                    // item.classList.add('active');
                    compareRemoveButton.style.display = 'inline-block';
                } else if ( currentProducts.length == 3 ) {
                    item.classList.add('disabled');
                    item.style.display = 'inline-block';
                } else {
                    item.style.display = 'inline-block';
                }


                compareRemoveButton.addEventListener('click', function(e) {
                    e.preventDefault();
                    removeFromCompare(this);
                    refreshCompare();
                    item.style.display = 'inline-block';
                    this.style.display = 'none';
                });


                item.addEventListener('click', function(e) {
                    e.preventDefault();

                    if( !item.classList.contains('active') && !item.classList.contains('disabled') ) {
                        addToCompare(id);
                        // item.classList.add('active');
                        item.style.display = 'none';
                        compareRemoveButton.style.display = 'inline-block';
                    }
                });
            });
        }

        if ( compareProductsList ) {
            loadCompareProducts(compareProductsList);
        }

        initCompareBox();
    });

    function readSavedProducts() {
        let storage = localStorage.getItem('comparedProducts');
        let savedProducts = [];

        if ( storage ) {
            savedProducts = JSON.parse(storage);
        }

        return savedProducts;
    }


    function addToCompare(id) {
        currentProducts = readSavedProducts();
        if ( currentProducts.length < 3 ) {
            currentProducts.push(id);
            localStorage.setItem( 'comparedProducts', JSON.stringify(currentProducts) );
            document.querySelector('[data-compare-count]').innerHTML = currentProducts.length;
            openCompareBox();
        }
    }

    function refreshCompare() {
        localStorage.setItem('comparedProducts', JSON.stringify(currentProducts));
        document.querySelector('[data-compare-count]').innerHTML = currentProducts.length;

        if ( !currentProducts.length ) {
            let box = document.querySelector('.compare__box.visible');
            if( box ) {
                box.classList.remove('visible');
            }
        }
    }

    function initCompareBox() {
        let box = document.querySelector('[data-compare-box]');
        let button = box.querySelector('.compare__boxIcon');
        let clear = box.querySelector('[data-clear-compare]');

        button.addEventListener('click', function() {
            box.classList.toggle("opened");
        });

        if( currentProducts.length ) {
            document.querySelector('[data-compare-count]').innerHTML = currentProducts.length;
            box.classList.add('visible');
        }

        if( clear ) {
            clear.addEventListener('click', function() {
                let activeCompareButtons = document.querySelectorAll('[data-add-to-compare].active');

                localStorage.removeItem('comparedProducts');
                box.classList.remove('visible');
                setTimeout(function() {
                    currentProducts = [];
                }, 10);

                if( activeCompareButtons.length ) {
                    activeCompareButtons.forEach(function(item) {
                        item.classList.remove('active');
                    });
                }

                document.querySelector('[data-add-to-compare].disabled').classList.remove('disabled');
            });
        }
    }

    function openCompareBox() {
        let box = document.querySelector('[data-compare-box]');

        if( !box.classList.contains('visible') ) {
            box.classList.add('visible');
        }

        setTimeout(function() {
            box.classList.add('opened');
        }, 100);

        setTimeout(function() {
            box.classList.remove('opened');
        }, 3000);
    }

    function loadCompareProducts(container) {
        let loader = document.querySelector('.loader');
        let sendObject = {
            action: 'getComparedProducts',
            products: currentProducts
        }

        jQuery.ajax({
            type : 'post',
            url : ajaxUrl,
            data: sendObject,
            beforeSend: function() {
                container.innerHTML = '';
                loader.classList.add('visible');
            },
            error: function( error ) {
                console.log(error);
            },
            success : function( response ) {
                loader.classList.remove('visible');
                container.innerHTML = response;

                setTimeout(function() {
                    initCompareSlider();
                }, 200);
            }
        });

    }


    function initCompareSlider() {
        let container = document.querySelector('[data-compare-products-list]');

        if  ( container ) {

            let slider = tns({
                container: container,
                items: 1,
                slideBy: 1,
                mode: 'carousel',
                autoplay: false,
                nav: true,
                autoplayButtonOutput: false,
                speed: 800,
                loop: false,
                autoHeight: true,
                responsive: {
                    600: {
                        items: 2,
                        gutter: 25
                    },
                    1200: {
                        items: 3,
                    },
                }
            });


            let buttons = document.querySelectorAll('[data-compare-remove]');

            if( buttons.length ) {
                buttons.forEach(function(item) {
                    item.addEventListener('click', function(e) {
                        e.preventDefault();
                        removeFromCompare(item, slider);
                    });
                })
            }
        }
    }


    function removeFromCompare(button, slider) {
        if( slider ) {
            slider.destroy();
        }

        let id = button.getAttribute('data-compare-remove');
        let slide = document.querySelector('[data-compared-product="'+ id +'"]');

        if( slide ) {
            slide.remove();
            slider.rebuild();
        }

        currentProducts = currentProducts.filter(function(ele){
            return ele != id;
        });

        refreshCompare();
    }
})()


//////////////////
// WEBPACK FOOTER
// ./js/compare.js
// module id = 9
// module chunks = 0